import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelectedBot } from '../contexts/SelectedBotContext.js';
import { requiresAgent } from '../constants/overviewNav.js';

// Bounces a user who has no agents yet out of any agent-scoped route and onto
// the Agents overview. Without this, a freshly-registered user (who lands on
// /overview) would see the full agent-level sidebar — and the header's bot
// selector — for an agent that doesn't exist. Both surfaces are path-driven,
// so this one redirect fixes both: on /my-bots the sidebar collapses to
// Agents / Workspaces / Team members and the bot selector hides.
//
// Only fires once the bot list has actually loaded (`loading === false`), so a
// real agent owner is never momentarily kicked off their page mid-fetch. Must
// be rendered inside SelectedBotProvider.
function NoAgentsRedirect() {
  const { bots, loading } = useSelectedBot();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (bots.length === 0 && requiresAgent(location.pathname)) {
      navigate('/my-bots', { replace: true });
    }
  }, [bots.length, loading, location.pathname, navigate]);

  return null;
}

export default NoAgentsRedirect;
